import axios, { AxiosResponse } from 'axios';
import { Asset } from '@/store/asset/types';

class WalletService {
  getUser(): Promise<AxiosResponse<Asset>> {
    return axios.get(`${process.env.VUE_APP_EXPORO_WALLET_API_URL}/user/current-user`)
    .then(({data}: any) => data.internalUser);
  }
}

export default new WalletService();